import {useAllCategoryGroupsQuery} from '@transactions/graphql';
import * as React from 'react';
import InputGroup from 'src/InputGroup';

type Props = {
  /** Selected group ID, or null for "No group". */
  value: string | null;
  onChange: (groupId: string | null) => void;
};

const NO_GROUP = '';

/**
 * "Group" select for category forms, wrapped in its own InputGroup.
 * Renders nothing while there are no groups to choose from — the field
 * only appears once grouping is in use.
 */
export const CategoryGroupSelect = ({value, onChange}: Props) => {
  const {data} = useAllCategoryGroupsQuery();
  const groups = data?.allCategoryGroups || [];

  if (groups.length === 0) {
    return null;
  }

  return (
    <InputGroup label="Group">
      <select
        value={value ?? NO_GROUP}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <option value={NO_GROUP}>No group</option>
        {groups.map((group) => (
          <option key={group._id} value={group._id}>
            {group.name}
          </option>
        ))}
      </select>
    </InputGroup>
  );
};
